/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * CAN_DRIVE — auto może jeździć. GROUNDED — auto nie powinno wyjeżdżać do czasu naprawy.
 */

export const CarIssueSeverityDto = {
    CanDrive: 'CAN_DRIVE',
    Grounded: 'GROUNDED',
} as const;

export type CarIssueSeverityDto = typeof CarIssueSeverityDto[keyof typeof CarIssueSeverityDto];



